import React, { useEffect, useState } from "react";
import { DigitalSignageDataContext } from "contexts/DigitalSignageDataContext";

export function DigitalSignageDataProvider({ children, ...props }) {
  const [data, setData] = useState(props.data);

  useEffect(() => {
    window.addEventListener("message", onMessageReceived, false);

    window.parent.postMessage("ready", "*");

    return () => {
      window.removeEventListener("message", onMessageReceived);
    };
  }, []);

  function onMessageReceived(e) {
    if (e.data.deviceConfiguration) {
      console.log("DIGITAL SIGNAGE DATA", e.data);
      try {
        setData(e.data);
      } catch (ex) {
        console.error(ex);
      }
    }
  }
  return (
    <DigitalSignageDataContext.Provider value={{ data }}>
      {typeof children === "function" && children({ data })}
      {typeof children !== "function" && children}
    </DigitalSignageDataContext.Provider>
  );
}
